// src/App.js
import React from 'react';
import {  Routes, Route } from 'react-router-dom';
import Mainpage from './components/mainpage';
import AuthModal from './components/LoginSignUP';
import Dashboard from './components/dashboard';
import InvestmentPage from './components/investmentpage';
import CoinRainTaskModal from './task/CoinRainTaskModal';
import EmailVerification from './components/verificationEmail';
import   AdminLayout  from './Admin/adminpanel';

import WorkersLoading from './components/loading';
import { useAppContext } from './context/AppContext';
import { useAuth } from './context/AuthContext';
import AboutUs from './components/aboutUs';
import ContactUs from './components/contact';
import { useAdmin } from './context/AdminContext';
import AdminLoginPage from './Admin/Adminloginpage';
import AdminProtectedRoute from './Admin/AdminProtectedRoute';
import ForgetPassword from './components/ForgetPassword';
import ForgetOtp from './components/ForgetOtp';
import ResetPassword from './components/ResetPassword';
import FlappyGame from './task/FlappyGame';
import LuckySpinner from './games/spiner/components/LuckySpinner';
import TicTacToe from './games/tictac/TicTacToe';

const App = () => {
    const { loading} = useAppContext();
    const { authLoading} = useAuth();
  const {
Adminloading} = useAdmin();
  return (

    <>
       {/* ✅ FULL SCREEN LOADING OVERLAY */}
    {(authLoading || loading || Adminloading) && (
  <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/30 backdrop-blur-md">
    <WorkersLoading />
  </div>
)}

     <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/login" element={<AuthModal />} />
      <Route path="/investment" element={<InvestmentPage />} />
      <Route path="/coin-game" element={<CoinRainTaskModal />} />
      <Route path="/verify-email" element={<EmailVerification />} />
<Route path="/plans" element={<Dashboard />} />
 {/* Admin Routes */}
 <Route path="/3workers_admin_hun_yara/login" element={<AdminLoginPage />} />
  <Route
  path="/3workers_admin_hun_yara/*"
  element={
    <AdminProtectedRoute>
      <AdminLayout />
    </AdminProtectedRoute>
  }
/>
    <Route path="/about" element={<AboutUs />} />
    <Route path="/contact" element={<ContactUs />} />



<Route path="/forget-password" element={<ForgetPassword />} />


<Route path="/forget-otp" element={<ForgetOtp />} />

<Route path="/reset-password" element={<ResetPassword />} />


{/* game routes */}
<Route path="/games/flappy" element={<FlappyGame />} />


  <Route path="/tic-tac-toe" element={<TicTacToe />} />
    </Routes>

      



    </>



  );
};

export default App;
